import { render } from "./AddBooking.vue?vue&type=template&id=2a281309&ts=true"
import script from "./AddBooking.vue?vue&type=script&lang=ts"
export * from "./AddBooking.vue?vue&type=script&lang=ts"

import "./AddBooking.vue?vue&type=style&index=0&id=2a281309&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__